import React from 'react';

import { useDirectionRadioGroupsOptions } from '@/features/customsPass/createNewRequest/hooks/useDirectionRadioGroupsOptions';
import { CROSSING_DIRECTION_COUNTRY } from '@/features/shared/constants';

type UseCreateNewRequestModal = {
  onCloseCreateNewRequestModal?: () => void;
};
type NewRequestForm = Partial<{
  direction: CROSSING_DIRECTION_COUNTRY;
  crossingRequestedDate: string;
  isRenewOrder: boolean;
}>;

export const useCreateNewRequestModal = ({ onCloseCreateNewRequestModal }: UseCreateNewRequestModal) => {
  const [newRequestForm, setNewRequestForm] = React.useState<NewRequestForm>({});

  const { directionRadioGroupsOptions } = useDirectionRadioGroupsOptions();

  const handleOnCloseModal = (_: unknown, reason: string) => {
    if (!['escapeKeyDown', 'backdropClick'].includes(reason)) {
      onCloseCreateNewRequestModal();
    }
  };

  const handleChangeDirection = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setNewRequestForm((state) => ({
      ...state,
      direction: event.target.value as CROSSING_DIRECTION_COUNTRY,
    }));
  }, []);

  const handleChangeCrossingRequestDate = React.useCallback(({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setNewRequestForm((state) => ({
      ...state,
      crossingRequestedDate: target.value,
    }));
  }, []);

  // const handleCheckRenewOrder = useCallback(({ target }: React.ChangeEvent<HTMLInputElement>) => {
  //   setNewRequestForm((state) => ({
  //     ...state,
  //     isRenewOrder: target.checked,
  //   }));
  // }, []);

  return {
    directionRadioGroupsOptions,
    newRequestForm,
    handleOnCloseModal,
    handleChangeDirection,
    handleChangeCrossingRequestDate,
  };
};
